import React from 'react';
import { Card, CardBody, CardHeader, CardFooter, Button } from 'reactstrap';

/**
 * OChartCard - standardized wrapper for chart widgets
 * - title, actions (e.g., filter buttons), loading, error, empty states
 */
const OChartCard = ({
	title,
	actions,
	isLoading,
	error,
	isEmpty,
	emptyIconClass = 'icon-info',
	emptyMessage = 'No hay datos para mostrar',
	children,
	footer,
}) => {
	// Fixed heights to prevent layout shift while loading
	const MIN_CARD_HEIGHT = 300;
	const MIN_BODY_HEIGHT = 240;

	return (
		<Card
			className='m-0 h-100 d-flex flex-column'
			style={{
				minHeight: MIN_CARD_HEIGHT,
				borderRadius: '1rem',
				overflow: 'hidden',
			}}
		>
			<CardHeader
				style={{ minHeight: '47px' }}
				className='p-2 px-3 align-items-center d-flex'
			>
				<h5 className='card-title mb-0 flex-grow-1'>{title}</h5>
				{actions}
			</CardHeader>

			<CardBody className='p-0 flex-grow-1' style={{ minHeight: MIN_BODY_HEIGHT }}>
				{isLoading ? (
					<div className='d-flex justify-content-center align-items-center p-4'>
						<div className='spinner-border text-primary' role='status' />
					</div>
				) : error ? (
					<div className='p-3'>
						<div className='alert alert-danger mb-0'>
							<div className='d-flex align-items-center gap-2'>
								<i className={`${Icons.alert} fs-5`}></i>
								<span>
									{error?.message ||
										'Ha ocurrido un error al cargar el gráfico'}
								</span>
								<span className='text-muted ms-auto fs-11'>
									Intente nuevamente
								</span>
							</div>
						</div>
					</div>
				) : isEmpty ? (
					<div className='d-flex justify-content-center align-items-center p-4'>
						<div className='text-center'>
							<div className='avatar-md'>
								<span className='avatar-title bg-info-subtle rounded-circle fs-1'>
									<i className={`${emptyIconClass} text-info`}></i>
								</span>
							</div>
							<div className='mt-2 text-muted fs-12'>{emptyMessage}</div>
						</div>
					</div>
				) : (
					children
				)}
			</CardBody>

			{footer ? (
				<CardFooter className='m-0 p-2 text-center'>{footer}</CardFooter>
			) : null}
		</Card>
	);
};

export default OChartCard;
